
<div>
  <h4>
    Detalles de Jaula
  </h4>

<!-- action buttons -->
  <div class="btn-group my-2">
    <button type="button"
    class="btn btn-outline-secondary"
          (click)="assignLocation()">
    Asignar Ubicación
  </button>
  <button type="button"
  class="btn btn-outline-secondary"
  (click)="editWeight()">
    Editar peso
  </button>
  <button type="button"
    class="btn btn-outline-secondary"
    (click)="editGuts()">
      Editar vísceras
    </button>
  </div>

  <hr />

  <app-summary-details [summaryItems]="summaryItems"></app-summary-details>

    <br />

  <igx-tabs>
    <igx-tabs-group label="Reses">
      <app-animals-details #animalsList></app-animals-details>
    </igx-tabs-group>
    <igx-tabs-group label="Visceras">
      <app-guts-details #gutsList></app-guts-details>
    </igx-tabs-group>
    <igx-tabs-group label="Piel">
      <app-skin-details #skinDetails></app-skin-details>
    </igx-tabs-group>
  </igx-tabs>

</div>
